import React, { Component } from "react";
import { Link } from "react-router";
import "./styles.scss";

export default class Footer extends Component {
  render() {
    var divStyle = {
      position: "absolute",
      left: "-5000px",
    };

    var displayNone = {
      display: "none",
    };
    return (
      <footer className="aboss__footer">
        <nav className="aboss__footer-content">
          <ul>
            <li>
              <strong>ABOSS</strong>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <a href="https://aboss.homerun.co/" target="_new">
                Jobs
              </a>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
          </ul>
          <ul>
            <li>
              <strong>Products</strong>
            </li>
            <li>
              <Link to="/products/artist">ABOSS Artist</Link>
            </li>
            <li>
              <Link to="/products/agency">ABOSS Agency</Link>
            </li>
            <li>
              <a href="https://changelog.a-boss.net" target="_new">
                Changelog
              </a>
            </li>
            <li>
              <a href="https://help.a-boss.net" target="_new">
                Support
              </a>
            </li>
          </ul>

          <ul>
            <li>
              <strong>Downloads</strong>
            </li>
            <li>
              <a
                href="https://itunes.apple.com/us/app/aboss/id1048993502?ls=1&mt=8"
                target="_applestore"
              >
                ABOSS for iOS
              </a>
            </li>
            <li>
              <a
                href="https://play.google.com/store/apps/details?id=com.aboss"
                target="_googlestore"
              >
                ABOSS for Android
              </a>
            </li>
          </ul>
          <ul></ul>

          <ul>
            <li className="newsletter">
              <strong>Newsletter</strong>
            </li>
            <li className="newsletter-copy">
              Stay up to date, subscribe to our newsletter
            </li>
            <li>
              <div id="mc_embed_signup">
                <form
                  action="https://a-boss.us13.list-manage.com/subscribe/post?u=4bf04500cc6048e6c494ece1f&amp;id=4093cb6fc7"
                  method="post"
                  id="mc-embedded-subscribe-form"
                  name="mc-embedded-subscribe-form"
                  className="validate"
                  target="_blank"
                  noValidate
                >
                  <div id="mc_embed_signup_scroll">
                    <div id="mce-responses" className="clear">
                      <div
                        className="response"
                        id="mce-error-response"
                        style={displayNone}
                      />
                      <div
                        className="response"
                        id="mce-success-response"
                        style={displayNone}
                      />
                    </div>
                    <div className="mce-input-container">
                      <div className="mc-field-group">
                        <label className="newsletter-label" htmlFor="mce-EMAIL">
                          Email address
                        </label>
                        <input
                          type="email"
                          name="EMAIL"
                          className="required email"
                          placeholder="Your email"
                          id="mce-EMAIL"
                          onChange={() => {}}
                        />
                      </div>
                      <div style={divStyle} aria-hidden="true">
                        <input
                          type="text"
                          name="b_4bf04500cc6048e6c494ece1f_4093cb6fc7"
                          tabIndex="-1"
                          value=""
                          onChange={() => {}}
                        />
                      </div>
                      <div className="clear">
                        <input
                          type="submit"
                          value="Subscribe"
                          name="subscribe"
                          id="mc-embedded-subscribe"
                          className="button"
                          onChange={() => {}}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </li>
          </ul>
        </nav>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// src/components/footer/index.js